/* eslint linebreak-style: ["error", "unix"] */
import Modal from 'components/modals/modal/modal';
import CloseButtonWhite from 'components/buttons/button-close/close-button.white';
import useModalWithQueryParams from 'hooks/useModalWithQueryParams';
import { ModalQueryParams } from 'data/app';
import SectionTitle from 'components/section-title/section-title';
import { useModalStyles } from 'styles/modal.styles';
import FormDocumentCategory from 'components/forms/form-document-category/form-document-category';

export default function ModalCreateDocumentCategory() {
  const classes = useModalStyles();

  // Modal
  const {
    isOpen,
    handleClose,
  } = useModalWithQueryParams(ModalQueryParams.CREATE_NEW_DOCUMENT_CATEGORY);

  return (
    <Modal className={classes.modal} open={isOpen} onClose={handleClose} closeButtonComponent={CloseButtonWhite} hasCloseButton>
      <SectionTitle>Criar categoria de documento</SectionTitle>
      <FormDocumentCategory onSuccess={handleClose} />
    </Modal>
  );
}
